import {Injectable} from "@angular/core";
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent} from "@angular/router";
import {distinctUntilChanged, filter, map} from "rxjs/operators";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {HelperService} from "./helperService";


@Injectable()
export class LayoutService
{


	/**
	 * Function > constructor
	 * @param {Router} OBJ_router
	 * @param {HelperService} OBJ_helper_service
	 * @param {Ng4LoadingSpinnerService} OBJ_spinner_service
	 */
	constructor(
		private OBJ_router: Router,
		private OBJ_helper_service: HelperService,
		private OBJ_spinner_service: Ng4LoadingSpinnerService
	)
	{

		this.OBJ_router.events.pipe(
			filter((OBJ_event: RouterEvent) => LayoutService.isConsideredEvent(OBJ_event)),
			map((OBJ_event: RouterEvent) => LayoutService.isNavigationStart(OBJ_event)),
			distinctUntilChanged()
		).subscribe((BOO_show_spinner) =>
		{

			// OBJ_helper_service.log(
			// 	{'class': 'LayoutService', 'function': 'constructor'},
			// 	{'BOO_show_spinner': BOO_show_spinner}
			// );
			if (BOO_show_spinner)
			{
				OBJ_helper_service.router_spinner = true;
				OBJ_spinner_service.show();
			} else
			{
				OBJ_helper_service.router_spinner = false;
				OBJ_spinner_service.hide();
			}

		});

	} // end function constructor


	/**
	 * Function > isConsideredEvent
	 * @param OBJ_event
	 */
	private static isConsideredEvent(OBJ_event: RouterEvent): boolean
	{
		// console.log(
		// 	{'class': 'LayoutService', 'function': 'isConsideredEvent'},
		// 	{'OBJ_event': OBJ_event}
		// );
		return LayoutService.isNavigationStart(OBJ_event)
			|| LayoutService.isNavigationEnd(OBJ_event);

	} // end function isConsideredEvent


	/**
	 * Function > isNavigationStart
	 * @param OBJ_event
	 */
	private static isNavigationStart(OBJ_event: RouterEvent): boolean
	{
		return OBJ_event instanceof NavigationStart;
	} // end function isNavigationStart


	/**
	 * Function > isNavigationEnd
	 * @param OBJ_event
	 */
	private static isNavigationEnd(OBJ_event: RouterEvent): boolean
	{
		return OBJ_event instanceof NavigationEnd
			|| OBJ_event instanceof NavigationCancel
			|| OBJ_event instanceof NavigationError;
	} // end function isNavigationEnd


} // end class LayoutService
